// Ordine cronologico: data, poi orario (senza orario in fondo alla giornata), senza data in fondo
export function compareEventDate(a: any, b: any): number {
  const da = a?.event?.date ? new Date(a.event.date).getTime() : Infinity;
  const db = b?.event?.date ? new Date(b.event.date).getTime() : Infinity;
  if (da !== db) return da < db ? -1 : 1;
  return timeKey(a?.event?.time).localeCompare(timeKey(b?.event?.time));
}

function timeKey(time: string | null | undefined): string {
  const m = /^(\d{1,2}):(\d{2})/.exec(time ?? '');
  return m ? `${m[1].padStart(2, '0')}:${m[2]}` : '99:99';
}

// Ultimi inseriti per primi
export function compareCreatedDesc(a: any, b: any): number {
  const ca = a?.createdAt ? new Date(a.createdAt).getTime() : 0;
  const cb = b?.createdAt ? new Date(b.createdAt).getTime() : 0;
  return cb - ca;
}
